import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetAllSerialNumbers(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetAllSerialNumbersAttempt', handleGetAllSerialNumbers, api);
}

function* handleGetAllSerialNumbers(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { ...restOfSerialNumberFilterParams } = reduxState.gold.params.serialNumberFilterParams;

    const response = yield* call([api, api.getAllSerialNumbers], {
        authToken,
        ...restOfSerialNumberFilterParams,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetAllSerialNumbersFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetAllSerialNumbersSuccess(response.data));
    }
}
